var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SingleCartItem',{attrs:{"item":_vm.item,"loading":_vm.loading,"discount-info":_vm.discountInfo},on:{"remove":_vm.remove,"update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }